import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { CSSProperties, ReactNode, useState } from "react"

export type CardTheme = "white" | "slate" | "dark"

export const Card = ({
  children,
  activeChildren,
  style,
  theme = "white",
  className,
  delay,
}: {
  children: ReactNode
  activeChildren?: ReactNode
  style?: CSSProperties
  theme?: CardTheme
  className?: string
  delay?: number
}) => {
  const [open, setOpen] = useState(false)

  return (
    <Appear className="w-full" delay={delay}>
      <div
        className={cn(
          "w-full aspect-[352/360] md:aspect-[341/420] rounded-md relative overflow-hidden group p-7 md:p-5",
          theme === "white" && "bg-white text-slate950",
          theme === "slate" && "bg-slate300 text-slate950",
          theme === "dark" && "bg-slate950 text-slate50",
          className,
        )}
        style={style}
        onClick={() => setOpen(!open)}
      >
        {children}

        {!env.admin && activeChildren && (
          <div
            className={cn(
              "absolute left-0 top-0 w-full h-full pointer-events-none transition-opacity duration-300 bg-slate600 p-7 md:p-5 text-white md:group-hover:opacity-100 md:group-hover:pointer-events-auto opacity-0",
              open && "opacity-100 pointer-events-auto",
            )}
          >
            {activeChildren}
          </div>
        )}

        <svg
          className={cn("w-8 h-8 absolute right-7 bottom-7 md:hidden", open && "hidden")}
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16" cy="16" r="16" fill="#E2E8F0" />
          <path
            d="M15.3077 16.6923H10V15.3077H15.3077V10H16.6923V15.3077H22V16.6923H16.6923V22H15.3077V16.6923Z"
            fill="#90A1B9"
          />
        </svg>

        <svg
          className={cn("w-8 h-8 absolute right-7 bottom-7 md:hidden", !open && "hidden")}
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16" cy="16" r="16" fill="#E2E8F0" />
          <path
            d="M15.3077 16.6924H10V15.3077H15.3077L16.6923 15.3078L22 15.3077V16.6924H16.6923H15.3077Z"
            fill="#90A1B9"
          />
        </svg>
      </div>
      {env.admin && activeChildren && (
        <div className={cn("w-full aspect-[341/420] rounded-md relative overflow-hidden bg-slate600 p-5 text-white")}>
          {activeChildren}
        </div>
      )}
    </Appear>
  )
}
